import { EntitetStatus } from "@dffedb/util";

export interface DbNoteBilag {
    dokumentid: string;
    fil: string; // Bruges til at gemme notedata
    filnavn: string;
    filstoerelse: string;
    status: EntitetStatus;
}
